<template>
  <div class="animated">
    <v-server-table
      id="analyte-result-server-table"
      :ref="ref"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      class="w-100"
    >
      <span slot="analyte" slot-scope="{row}">
        {{ row.analyte.name }}
      </span>

      <span slot="result" slot-scope="{row}">
        {{ getResultInfo(row) }}
      </span>
    </v-server-table>
  </div>
</template>

<script>
import Vue from 'vue'
import AnalyteResultCollection from '@/collections/lab/AnalyteResultCollection'
import BaseServerTable from '@/components/shared/BaseServerTable'
import { ServerTable } from 'vue-tables-2'

Vue.use(ServerTable)

export default {
  name: 'AnalyteResultServerTable',
  extends: BaseServerTable,
  props: {
    collection: {
      type: Object,
      default: () => new AnalyteResultCollection()
    },
    show_columns: {
      type: Array,
      default: () => [
        'analyte',
        'instrument_instance.instrument.name',
        'result',
        'created_by.name',
        'evaluated_by.name',
        'status'
      ]
    },
    filterable: {
      type: Array,
      default: () => ['searchable']
    },
    sortable: {
      type: Array,
      default: () => ['instrument_instance.instrument.name']
    },
    sample_id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      table_config: _.merge(this.getDefaultTableConfig(), {
        options: {
          headings: {
            'instrument_instance.instrument.name': 'Instrument Name',
            'created_by.name': 'Created By',
            'evaluated_by.name': 'Evaluated By'
          },
          filterable: this.filterable,
          sortable: this.sortable
        }
      }),
      table_data: {
        sample_type: ['analyte', 'sample_type'],
        instrument: ['instrument_instance', 'instrument'],
        status: ['current_analyte_result_status_log', 'analyte_result_status']
      }
    }
  },
  methods: {
    prepareCollectionFilter (filter) {
      const connections = [
        'analyte.sample_type',
        'sample',
        'created_by',
        'instrument_instance.instrument',
        'unit_of_measure',
        'current_analyte_result_status_log.analyte_result_status'
      ]

      connections.forEach((connection) => {
        filter.connectionAdd(connection)
      })

      this.sample_id && filter.filterEquals('sample_id', this.sample_id)

      return filter
    },

    getResultInfo ({ analyte, formatted_result, raw_result, unit_of_measure }) {
      console.log('getResultInfo', analyte, formatted_result, raw_result, unit_of_measure)
      const unit = unit_of_measure ? unit_of_measure.abbrev : ''

      return analyte && analyte.name === 'Completion'
        ? raw_result
          ? 'Completed'
          : 'Not-Complete'
        : `${formatted_result}${unit}`
    }
  }
}
</script>
